import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Button, Checkbox } from 'semantic-ui-react';
import RefreshButton from '../../components/RefreshButton';

import * as Events from '../../store/Events';

class EventList extends Component {
    constructor(props) {
        super(props);
        
        this.onAddClick = this.onAddClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onInventoryClick = this.onInventoryClick.bind(this);
        this.onCustomFieldClick = this.onCustomFieldClick.bind(this);
    }

    onAddClick(e) {
        const {actions} = this.props;
        actions.push('/admin/event/add');
    }

    onEditClick(e, {data}){
        const {actions} = this.props;
        actions.push(`/admin/event/${data}`);
    }

    onInventoryClick(e, {data}){
        const {actions} = this.props;
        actions.push(`/admin/event/${data}/inventory`);
    }

    onCustomFieldClick(e, {data}) {
        const {actions} = this.props;
        actions.push(`/admin/event/${data}/customfields`);
    }
    
    render() {
        const {event, actions} = this.props;
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign="center">Events</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}><RefreshButton floated="right" action={async () => await actions.getEvents()} /></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {Object.values(event.events).map((f, index) => (
                            <Table.Row>
                                <Table.Cell>
                                    <Button content="edit" data={f.id} onClick={this.onEditClick} />
                                    <Button content="inventory" data={f.id} onClick={this.onInventoryClick} />
                                    <Button content="custom fields" data={f.id} onClick={this.onCustomFieldClick} />
                                </Table.Cell>
                                <Table.Cell>{f.name}</Table.Cell>
                                <Table.Cell><Checkbox checked={f.isPublished} label="Published" disabled /></Table.Cell>
                                {/* <Table.Cell>{`${f.address}, ${f.city}, ${f.state} ${f.zip}`}</Table.Cell> */}
                            </Table.Row>
                        ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Table.HeaderCell colSpan={2}>
                                <Button floated='right' content="Add" onClick={this.onAddClick} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        );
    }
}

EventList.propTypes = {
    event: PropTypes.object,
    actions: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
    return {
        event: Events.selector(state)
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventList));